class SyosAjaxError extends Error {
  constructor(requestOptions, jqXHR, reason, status) {
    super(`SyosAjaxError - request failed for path '${requestOptions.url}' - Reason: ${reason}, Status: ${status}`);

    this.requestOptions = requestOptions;
    this.jqXHR = jqXHR;
    this.reason = reason;
    this.status = status;
  }
}

export default SyosAjaxError;
